import { useEffect, useState } from "react";
import api from "@/lib/api";
import { TID } from "@/constants/testIds";
import { PlaceholderBanner } from "@/components/common/PlaceholderBanner";
import { Link } from "react-router-dom";

export default function AssessmentsPage() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/assessments").then(r => setRows(r.data)); }, []);

  return (
    <div data-testid={TID.assessmentsPage} className="space-y-6 animate-fade-in-up">
      <header className="flex items-end justify-between border-b border-border pb-4">
        <div>
          <div className="text-[10px] uppercase tracking-[0.22em] text-altara-teal font-semibold">Assessments</div>
          <h1 className="font-display text-3xl font-semibold tracking-tight text-altara-ink mt-1">Consumer understanding assessments</h1>
          <p className="text-sm text-muted-foreground mt-1">MOCKED integration. Assessment scores drive deterministic literacy bands used by the rules engine.</p>
        </div>
        <div className="font-mono text-[10px] text-muted-foreground">{rows.length} records</div>
      </header>

      <PlaceholderBanner message="This page reads from a MOCKED assessment adapter. When the real Altara Consumer Education platform is wired, records surface here automatically." />

      <div className="border border-slate-200 rounded-sm overflow-hidden bg-white">
        <table className="w-full text-xs">
          <thead className="bg-slate-50 text-[10px] uppercase tracking-[0.15em] text-slate-500">
            <tr>
              <th className="text-left px-4 py-2 font-medium">Consumer</th>
              <th className="text-left px-4 py-2 font-medium">Topic</th>
              <th className="text-left px-4 py-2 font-medium">Score</th>
              <th className="text-left px-4 py-2 font-medium">Band</th>
              <th className="text-left px-4 py-2 font-medium">Knowledge gaps</th>
              <th className="text-left px-4 py-2 font-medium">Taken</th>
            </tr>
          </thead>
          <tbody>
            {rows.map(r => (
              <tr key={r.assessment_id} className="border-t border-slate-100 hover:bg-slate-50/60">
                <td className="px-4 py-2"><Link to={`/consumers/${r.consumer_id}`} className="font-mono text-[10px] text-altara-teal hover:text-altara-deep">{r.consumer_id.slice(0, 12)}…</Link></td>
                <td className="px-4 py-2 text-slate-800">{r.topic}</td>
                <td className="px-4 py-2 font-mono tabular-nums">{r.score}</td>
                <td className="px-4 py-2 uppercase text-[10px] tracking-widest text-slate-600">{r.band}</td>
                <td className="px-4 py-2">
                  <div className="flex flex-wrap gap-1">
                    {(r.knowledge_gaps || []).map(g => <span key={g} className="text-[10px] bg-amber-50 border border-amber-200 text-amber-800 px-1.5 py-0.5 rounded-sm">{g}</span>)}
                    {(r.knowledge_gaps || []).length === 0 && <span className="text-[10px] text-slate-400">—</span>}
                  </div>
                </td>
                <td className="px-4 py-2 font-mono text-[10px] text-slate-500">{new Date(r.taken_at).toLocaleDateString()}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={6} className="px-4 py-8 text-center text-slate-400">No assessments yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
